import type { AxiosRequestConfig } from 'axios'
import type { ResErr } from 'src/types/common/api'

type CommonErrorParams = {
  type?: 'API' | 'client' | 'CORS'
  disableToast?: boolean
  config?: AxiosRequestConfig
} & Partial<Pick<Response, 'status' | 'url'> & ResErr>

export class CommonError<DataT = null> extends Error {
  override name = 'CommonError'
  status?: CommonErrorParams['status']
  type?: CommonErrorParams['type']
  code?: ResErr['code']
  data?: ResErr<DataT>['data']
  disableToast: CommonErrorParams['disableToast']
  config?: CommonErrorParams['config']

  constructor(message: string, options?: CommonErrorParams) {
    super(message)
    Object.assign(this, options)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CommonError)
    }
  }
}
